import { render, staticRenderFns } from "./OffCanvas.vue?vue&type=template&id=17bc641b&"
import script from "./OffCanvas.vue?vue&type=script&lang=js&"
export * from "./OffCanvas.vue?vue&type=script&lang=js&"
import style0 from "./OffCanvas.vue?vue&type=style&index=0&id=17bc641b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports